import { frontendURL } from '../../../helper/URLHelper';

const ChangelogPage = () => import('./ChangelogPage.vue');

const meta = {
  permissions: ['administrator', 'agent', 'custom_role'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/changelog'),
    name: 'changelog',
    component: ChangelogPage,
    meta,
  },
];
